import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-assessors-invite',
  templateUrl: 'assessors-invite.component.html',
  styleUrls: ['./assessors-invite.component.less', '../../../shared/common.less'],
})

export class AssessorsInviteComponent implements OnInit {
  @Input() isValidated: boolean = false;
  @Output() inviteAssessorsEvent = new EventEmitter();

  ngOnInit(): void {
  }
}
